import React, {useState,useEffect} from 'react'
import "./About.scss"
import { AppWrap } from '../../wrapper'
import { motion } from 'framer-motion'
import { urlFor,client } from '../../client'

const About = () => {

  const [abouts, setAbouts] = useState([])

  const requestAbouts = async ()=>{

    const query = '*[_type == "abouts"]'

    try {

      const response = await client.fetch(query)
      setAbouts(response)
    } catch (error) {      
      console.error(error)
    }
  }

  useEffect(() => {
    requestAbouts()
  }, []); 

  return (
    <>
      <h2 className="head-text">I Know that <span>Good Design</span> <br />means  <span>Good Business</span></h2>
      <div className="app__profiles">
        {
          abouts.map((about,index)=>(
            <motion.div
              whileInView={{opacity:[0,1]}}
              whileHover={{scale:1.1}}
              transition={{duration:0.5,type:"tween"}}
              className="app__profile-item"
              key={about.title + index}
            >
              <img src={urlFor(about.imgUrl)} alt={about.title}/>
              <h2 
                className="bold-text" 
                style={{marginTop: 20}}
              >
                {about.title}
              </h2>
              <p
                className="p-text"
                style={{ marginTop: 10 }}
              >
                {about.description}
              </p>              
            </motion.div>
          ))
        }
      </div>
    </>
  )
}

export default AppWrap(About,"about");